import { ENCRYPT_STORAGE, SET_STARTUP, WebWidth } from "../../config/config";
import { STORE_HardReleaseVersion } from "../../database/store-names";
import { PT_SETTINGS, PT_STARTUP } from "../../routes/stack/paths/pt-home";
import { get_Href_URL_Params } from "../../functions/funtion";
import { REQUEST_PUSHTOKEN } from "../../functions/mobile-intigrator";
import { dto_Customer } from "../../classes/dto-customer";
import React from "react";

export default class Configure extends React.Component {
  state = {
    isLoading: true,
  };

  async componentDidMount() {
    let { csp } = this.props.params;
    let HardReleaseVersion = ENCRYPT_STORAGE.getItem(STORE_HardReleaseVersion);
    const hasVersion =
      HardReleaseVersion !== undefined &&
      HardReleaseVersion !== null &&
      HardReleaseVersion !== "" &&
      HardReleaseVersion !== "undefined";
    await REQUEST_PUSHTOKEN();
    await SET_STARTUP({ csp: csp, HardReleaseVersion: HardReleaseVersion });

    // After loading is complete, set isLoading to false
    this.setState({ isLoading: false });

    setTimeout(() => {
      if (dto_Customer.CSID !== 18755100) {
        const startupPath = hasVersion
          ? PT_STARTUP.replace(":csp", csp + "?ver=" + HardReleaseVersion)
          : PT_STARTUP.replace(":csp", csp);
        this.props.navigate(
          startupPath
        );
      }
    }, 0.00001);
  }

  render() {
    // If the component is loading, display a loading message
    if (this.state.isLoading) {
      return (
        <div
          className="loader"
          style={{ marginTop: "90%", marginLeft: "45%" }}
        />
      );
    }

    // Once loading is complete, display the main content
    return (
      <div
        style={{
          width: WebWidth,
          height: "100%",
          backgroundColor: "#f0f0f0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
          justifyContent: "center",
        }}
      >
        <button
          style={{
            width: "150px",
            margin: "10px",
            padding: "10px",
            backgroundColor: "#3498db",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            this.props.navigate(PT_SETTINGS);
          }}
        >
          Go To Settings
        </button>

        <br />

        <button
          style={{
            width: "150px",
            margin: "10px",
            padding: "10px",
            backgroundColor: "#2ecc71",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            let { csp } = this.props.params;
            let HardReleaseVersion = get_Href_URL_Params().ver;
            const startupPath =
              HardReleaseVersion &&
              HardReleaseVersion !== "undefined"
                ? PT_STARTUP.replace(":csp", csp + "?ver=" + HardReleaseVersion)
                : PT_STARTUP.replace(":csp", csp);
            this.props.navigate(
              startupPath
            );
          }}
        >
          Go To App
        </button>
      </div>
    );
  }
}
